<h1 mat-dialog-title>{{ data.title | translate }}</h1>
<div mat-dialog-content>
  <p>{{ data.content | translate }}</p>
  <mat-radio-group [(ngModel)]="selectedChoice">
    <p *ngFor="let choice of data.choices">
      <mat-radio-button [value]="choice.value">
        {{ choice.title | translate }}
      </mat-radio-button>
    </p>
  </mat-radio-group>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="undefined" cdkFocusInitial>
    {{ "DIALOG.CANCEL" | translate }}
  </button>
  <button
    mat-button
    [mat-dialog-close]="selectedChoice"
    [disabled]="!selectedChoice"
  >
    {{ "DIALOG.CONFIRM_SELECTION" | translate }}
  </button>
</div>
